import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";

import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import AddCircleIcon from "@material-ui/icons/AddCircle";

import { useStyles } from "../../../../../Components/CSS/FormStyle.css";
import Axios from "axios";
import { url } from "../../../../../Config/Config";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { getAdminRefreshToken } from "../../../../../Redux/Actions/actions";
import FormLoader from "../../../../../Components/FormLoader/FormLoader";

class AddDecreaseStock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      decreasedData: {
        quantity: this.props.decreasedData.quantity,
        remarks: this.props.decreasedData.remarks,
      },
      loading: false,
    };
  }

  handleChange = (e) => {
    this.setState({
      decreasedData: {
        ...this.state.decreasedData,
        [e.target.name]: e.target.value,
      },
    });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    try {
      this.setState({ loading: true });
      let data = { ...this.state.decreasedData, date: new Date() };
      const response = await Axios.post(
        `${url}/api/item-categories/${this.props.categoryId}/decrement`,
        data,
        {
          headers: { Authorization: `Bearer ${this.props.adminToken}` },
        }
      );
      if (response.data.message === "Successfull") {
        this.setState({
          decreasedData: {
            quantity: 0,
            remarks: "",
          },
          loading: false,
        });
        this.props.getCategoryDetails(this.props.categoryId);
      }
    } catch (error) {
      this.setState({ loading: false });
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.handleSubmit(e);
      }
    }
  };

  handleUpdate = async () => {
    try {
      this.setState({ loading: true });
      let data = { ...this.state.decreasedData, date: this.props.data.date };
      const response = await Axios.put(
        `${url}/api/item-categories/${this.props.categoryId}/decrement/${this.props.decreaseId}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${this.props.adminToken}`,
          },
        }
      );
      if (response.data.message === "Decrement updated successfully") {
        this.props.handleCancelEdit();
        this.props.getCategoryDetails(this.props.categoryId);
      }
    } catch (error) {
      this.setState({ loading: false });
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.handleUpdate();
      }
    }
  };

  render() {
    const { decreasedData } = this.state;
    const { classes } = this.props;
    return (
      <TableRow>
        <TableCell />
        <TableCell align="center">
          <TextField
            name="quantity"
            type="number"
            required
            fullWidth
            variant="outlined"
            margin="normal"
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={decreasedData.quantity}
            onChange={this.handleChange}
          />
        </TableCell>
        <TableCell align="center">
          <TextField
            name="remarks"
            type="text"
            required
            fullWidth
            multiline
            rows={3}
            rowsMax={6}
            variant="outlined"
            margin="normal"
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={decreasedData.remarks}
            onChange={this.handleChange}
          />
        </TableCell>
        <TableCell align="center">
          {this.props.editStatus ? (
            <>
              <Tooltip
                arrow
                title="Update Data"
                onClick={this.handleUpdate}
                className={classes.tooltip}
              >
                <CheckCircleIcon />
              </Tooltip>
              <Tooltip
                arrow
                title="Update Data"
                onClick={this.props.handleCancelEdit}
                className={classes.tooltip}
              >
                <CancelIcon />
              </Tooltip>
            </>
          ) : (
            <Tooltip
              arrow
              title="Add Data"
              onClick={this.handleSubmit}
              className={classes.tooltip}
            >
              <AddCircleIcon />
            </Tooltip>
          )}
          <br />
          {this.state.loading && <FormLoader />}
        </TableCell>
      </TableRow>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(AddDecreaseStock)));
